"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_LANGUAGE = void 0;
Object.defineProperty(exports, "IntlMessages", {
  enumerable: true,
  get: function get() {
    return _IntlMessages.default;
  }
});
Object.defineProperty(exports, "IntlNumber", {
  enumerable: true,
  get: function get() {
    return _IntlNumber.default;
  }
});
exports.OTHER_LANGUAGES = exports.LOCALES = void 0;
Object.defineProperty(exports, "injectIntl", {
  enumerable: true,
  get: function get() {
    return _reactIntl.injectIntl;
  }
});
var _lodash = _interopRequireDefault(require("lodash"));
var _reactIntl = require("react-intl");
var _IntlMessages = _interopRequireDefault(require("./IntlMessages"));
var _IntlNumber = _interopRequireDefault(require("./IntlNumber"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var DEFAULT_LANGUAGE = process.env.REACT_APP_TRANSLATE_DEFAULT_LANGUAGE || 'fr';
// we parse the other languages because we use it as array in the env
// use use in this moment 'ar' | 'en' | 'fr' | 'de' | 'gr' | 'jp' | 'ru' | 'es' | 'sv' | 'tr'
exports.DEFAULT_LANGUAGE = DEFAULT_LANGUAGE;
var OTHER_LANGUAGES = JSON.parse(process.env.REACT_APP_TRANSLATE_OTHER_LANGUAGES || '[]');
exports.OTHER_LANGUAGES = OTHER_LANGUAGES;
var localesData = [];
var _iterator = _createForOfIteratorHelper(_lodash.default.concat([DEFAULT_LANGUAGE], OTHER_LANGUAGES)),
  _step;
try {
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    var lng = _step.value;
    try {
      var localeData = require("react-intl/locale-data/".concat(lng));
      localesData = _lodash.default.concat(localesData, localeData);
    } catch (error) {
      throw new Error('locale-data not found', error);
    }
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}
(0, _reactIntl.addLocaleData)(localesData);
var LOCALES = _lodash.default.concat([DEFAULT_LANGUAGE], OTHER_LANGUAGES);
exports.LOCALES = LOCALES;